import routeNames from './route-names'
import BaseRouterView from '@/components/base/BaseRouterView'

const Invoices = () => import(/* webpackChunkName: "invoices" */'@/views/invoice/Invoices')
const InvoiceTabs = () => import(/* webpackChunkName: "invoices" */'@/views/invoice/invoice/InvoiceTabs')
const Overview = () => import(/* webpackChunkName: "invoices" */'@/views/invoice/invoice/Overview')

function props (route) {
    return {
        invoiceId: parseInt(route.params.invoiceId)
    }
}

export default {
    path: '/customers/invoices',
    component: BaseRouterView,
    children: [
        {
            path: '/',
            name: routeNames.INVOICES,
            meta: {title: 'Invoices'},
            component: Invoices
        },
        {
            path: ':invoiceId',
            component: InvoiceTabs,
            props,
            children: [
                {
                    path: '/',
                    name: routeNames.INVOICE,
                    meta: {title: 'Invoice'},
                    component: Overview,
                    props
                }
            ]
        }
    ]
}
